import { Component, ChangeDetectionStrategy, ElementRef, Renderer2, Input } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { PlainJaneIndexCardStackBackgroundViewModel } from './plain-jane-index-card-stack-background-view-model';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-plain-jane-index-card-stack-background',
  templateUrl: './plain-jane-index-card-stack-background.component.html',
  styleUrls: ['./plain-jane-index-card-stack-background.component.scss'],
  providers: [PlainJaneIndexCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PlainJaneIndexCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: PlainJaneIndexCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
